import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'lib-retail-order-status',
  template: `
    @if (
      {
        row: columnData | async,
        adata: additionData | async,
      };
      as $
    ) {
      <div class="flex align-items-center">
        <div class="w-4rem">
          @if ($.row && $.adata.fetch_key && ($.row[$.adata.fetch_key].toLowerCase() === 'completed' || $.row[$.adata.fetch_key] === '2')) {
            <p-tag severity="info" class="text-xxs font-normal uppercase white-space-nowrap">Completed</p-tag>
          }
          @if ($.row && $.adata.fetch_key && ($.row[$.adata.fetch_key].toLowerCase() === 'pending' || $.row[$.adata.fetch_key] === '1')) {
            <p-tag severity="warn" class="text-xxs font-normal uppercase white-space-nowrap">Pending</p-tag>
          }
        </div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, AsyncPipe],
})
export class OrderStatusComponent {
  columnData: Observable<any> = new BehaviorSubject<any>(null);
  additionData: Observable<any> = new BehaviorSubject<any>(null);
}
